import { GxButton } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/tag.module.scss'

interface IProps {
  active?: boolean
  children: any
  onClick: () => void
}

const TagButton = ({
  active = false,
  children,
  onClick
}: IProps): React.ReactElement => {
  return (
    <GxButton
      variant='primary'
      className={classNames({
        [style.tag]: true,
        [style.active]: active
      })}
      onClick={onClick}
    >
      {children}
    </GxButton>
  )
}

export default TagButton
